const FeaturedProductGrid = class extends HTMLElement {
  connectedCallback() {
    if (this.dataset.stackProducts === 'true') return;

    const productGrid = this.querySelector('.product-grid');
    const showMoreButton = this.querySelector('#view-more-button');
    const showLessButton = this.querySelector('#view-less-button');
    const productItems = this.querySelectorAll('.product-item');

    const getVisibleItemsCount = () => {
      const screenWidth = window.innerWidth;
      return screenWidth >= 769
        ? parseInt(this.dataset.productsPerRowDesktop, 10)
        : parseInt(this.dataset.productsPerRowMobile, 10);
    };

    let visibleItemsCount = getVisibleItemsCount();

    const updateButtonStates = () => {
      const totalVisible = productItems.length;
      const isDesktop = window.innerWidth >= 769;

      const moreClass = showMoreButton.className;
      const lessClass = showLessButton.className;

      const allowMore = moreClass.includes('view-more--both')
          || (isDesktop && moreClass.includes('view-more--desktop'))
          || (!isDesktop && moreClass.includes('view-more--mobile'));

      const allowLess = lessClass.includes('view-less--both')
          || (isDesktop && lessClass.includes('view-less--desktop'))
          || (!isDesktop && lessClass.includes('view-less--mobile'));

      const allowNone = moreClass.includes('view-more--none') && lessClass.includes('view-less--none');

      if (allowNone) {
        showMoreButton.style.display = 'none';
        showLessButton.style.display = 'none';
        return;
      }

      if (visibleItemsCount >= totalVisible) {
        showMoreButton.style.display = 'none';
        showLessButton.style.display = allowLess ? 'inline-block' : 'none';
      } else {
        showMoreButton.style.display = allowMore ? 'inline-block' : 'none';
        showLessButton.style.display = 'none';
      }
    };

    const initProductVisibility = () => {
      visibleItemsCount = getVisibleItemsCount();
      productItems.forEach((item, index) => {
        item.classList.toggle('visible', index < visibleItemsCount);
      });
      updateButtonStates();
    };

    const handleShowMore = () => {
      visibleItemsCount += getVisibleItemsCount();
      let lastVisible;

      productItems.forEach((item, index) => {
        if (index < visibleItemsCount) {
          item.classList.add('visible');
          lastVisible = item;
        }
      });

      updateButtonStates();

      lastVisible?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleShowLess = () => {
      visibleItemsCount = getVisibleItemsCount();

      productItems.forEach((item, index) => {
        if (index >= visibleItemsCount) {
          item.classList.remove('visible');
        }
      });

      updateButtonStates();

      productGrid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handleResize = () => {
      const newVisibleCount = getVisibleItemsCount();
      if (newVisibleCount !== visibleItemsCount) {
        visibleItemsCount = newVisibleCount;
        productItems.forEach((item, index) => {
          item.classList.toggle('visible', index < visibleItemsCount);
        });
        updateButtonStates();
      }
    };

    showMoreButton?.addEventListener('click', handleShowMore);
    showLessButton?.addEventListener('click', handleShowLess);
    window.addEventListener('resize', handleResize);

    initProductVisibility();
  }
};

if (!window.customElements.get('featured-product-grid')) {
  customElements.define('featured-product-grid', FeaturedProductGrid);
}

export default FeaturedProductGrid;
